import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faAngleRight, faEarthAmericas, faPhone, faGlobe, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faLinkedin, faVimeo } from '@fortawesome/free-brands-svg-icons';

library.add(faChevronRight);
library.add(faAngleRight);
library.add(faLocationDot);
library.add(faPhone);
library.add(faGlobe);
library.add(faEarthAmericas);
library.add(faFacebook);
library.add(faLinkedin);
library.add(faVimeo);

// Call dom.i2svg() to replace <i> tags with <svg> icons
dom.i2svg();
